import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem(['seq'], 5, 'ASC'),
	itensSelecionados: [],
	isSelecionouTodosItensAdesao: false,
}
